import React from "react";

const Shipping_delivery = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8">
          
          {/* Page Header */}
          <div className="text-center mb-5">
            <h1 className="fw-bold text-dark mb-3">
              Shipping & Delivery Policy
            </h1>
            <p className="text-muted border-top border-bottom py-3 mx-auto" style={{maxWidth: '400px'}}>
              Last updated on November 13, 2025
            </p>
          </div>

          {/* Introduction */}
          <div className="mb-5 p-4 bg-info bg-opacity-10 border-start border-3 border-info rounded-end">
            <div className="mb-4 text-start">
              <h5 className="text-dark mb-2">MyFoodMyPrice is a product of Biryani Palayam.</h5>
              <p className="fs-6 text-dark mb-0">
                Click here to visit{" "}
                <a href="https://www.biryanipalayam.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-primary fw-semibold border-bottom border-primary">
                  Biryani Palayam
                </a>
              </p>
            </div>
            <p className="fs-5 mb-0 text-dark">
              Orders placed through the MyFoodMyPrice (MFMP) app are generally
              pickup-only.
            </p>
          </div>

          {/* Pickup Policy */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  1
                </span>
                Pickup Policy
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">✓</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Customers can select their preferred pickup point from the options
                    provided in the MFMP app.
                  </p>
                </div>
              </div>
              
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">✓</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Orders will be prepared and kept ready for pickup at the selected
                    pickup location and time.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Delivery Policy */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  2
                </span>
                Delivery Policy
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Home delivery is not the default option on MFMP.
                  </p>
                </div>
              </div>
              
              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Delivery can be arranged upon request, subject to availability, at
                    an additional nominal cost.
                  </p>
                </div>
              </div>
              
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Delivery availability and charges will be communicated at the time
                    of order or coordination.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Delays & Exceptions */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  3
                </span>
                Delays & Exceptions
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">!</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    MyFoodMyPrice shall not be held liable for delays caused due to
                    factors beyond its control, including traffic congestion, road
                    closures, or adverse weather conditions.
                  </p>
                </div>
              </div>
              
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">⏱</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    While we strive to ensure timely readiness of orders, customers are
                    requested to allow a leeway of up to <strong>30 minutes</strong>{" "}
                    from the selected pickup or delivery time in case of unforeseen
                    delays.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Order Status */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-info text-dark rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  4
                </span>
                Order Status
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-info bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">📱</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Order status and pickup details can be tracked through the
                    MyFoodMyPrice app.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Support */}
          <div className="card border-0 shadow-sm rounded-3">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  5
                </span>
                Support
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <p className="fs-5 mb-0 text-dark" style={{ lineHeight: '1.8', wordBreak: 'break-word' }}>
                For any issues related to orders or services, customers may contact
                us at{" "}
                <a
                  href="mailto:Info@myfoodmyprice.com"
                  className="text-decoration-none text-primary fw-semibold border-bottom border-primary"
                >
                  Info@myfoodmyprice.com
                </a>
                <span className="mx-2 text-muted">|</span>
                <a
                  href="mailto:support@biryanipalayam.com"
                  className="text-decoration-none text-primary fw-semibold border-bottom border-primary"
                >
                  support@biryanipalayam.com
                </a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Shipping_delivery;